// this is an autogenerated file from App/Account/Content/Settings/Content/Leads/Content/Content/Settings/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_Leads_Content_Content_Settings($configuration_id: uuid!) {
  leads_settings(where: { configuration_id: { _eq: $configuration_id } }) {
    id
    key
    value
  }
  leads_questions(
    where: {
      configuration_id: { _eq: $configuration_id }
      resource_id: { _eq: "insurance" }
    }
  ) {
    id
    resource_id
  }
  leads_configurations_by_pk(id: $configuration_id) {
    id
    organization {
      name
      level
    }
  }
}

`